import script from "./RequestMainForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestMainForm.vue?vue&type=script&setup=true&lang=js"

import "./RequestMainForm.vue?vue&type=style&index=0&id=2d7775d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d7775d4"]])

export default __exports__